import type { SetupSection } from '../setupSections';

/** Bereich der Einrichtung, der zum Paket gehört, aber noch nicht umgesetzt ist */
export function SetupPlaceholderPage({ section }: { section: SetupSection }) {
  return (
    <section className="card">
      <h2>{section.label}</h2>
      <p>{section.description}</p>
      <p className="muted">Dieser Bereich ist in Vorbereitung und noch nicht verfügbar.</p>
    </section>
  );
}
